/**
 * 小时阅读卡语言独立配置契约（AB-运营应用 §7）；五项整份替换，不逐字段继承。
 */
import { z } from 'zod';
import {
  ReadingPassFreeTrialRemindMaxCountSchema,
  ReadingPassFreeTrialRemindTimeSchema,
  ReadingPassUnlockReadingDayThresholdSchema,
} from './apps';
import { LanguageCodeSchema } from './system-config';

export const ReadingPassLanguageConfigParamsSchema = z.object({
  id: z.string().uuid(),
  language: LanguageCodeSchema,
});

export const UpsertReadingPassLanguageConfigRequestSchema = z
  .object({
    is_enabled: z.boolean(),
    unlock_reading_day_threshold: ReadingPassUnlockReadingDayThresholdSchema,
    is_free_trial_remind_enabled: z.boolean(),
    free_trial_remind_time: ReadingPassFreeTrialRemindTimeSchema,
    free_trial_remind_max_count: ReadingPassFreeTrialRemindMaxCountSchema,
  })
  .strict();

export type UpsertReadingPassLanguageConfigRequest = z.infer<
  typeof UpsertReadingPassLanguageConfigRequestSchema
>;

export interface ReadingPassLanguageConfigResponse extends UpsertReadingPassLanguageConfigRequest {
  language: string;
  created_at: string;
  updated_at: string;
}
